import { http } from 'services/http';
import type { CreateTransportReq, TransportRes } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';
import { TRANSPORTS_LIST } from '../query-keys.ts';

export const useCreateTransport = () => {
  return useMutationBase<TransportRes, unknown, CreateTransportReq>({
    mutationFn: async (variables) => {
      const res = await http.post<TransportRes>('/v1/transports', variables);

      return res.data;
    },

    invalidateCallback: () => [[TRANSPORTS_LIST]],
  });
};
